import PropTypes from 'prop-types';
import React from 'react';
import Stepper from 'src/components/ui/Stepper';
import { MAINTENANCE_STEPS } from 'src/constants/maintenance';

/**
 * Pinned 4-step operator wizard (Choose · Plan · Do the work · Finish) shown
 * under the app-bar during the flow — a sticky bar hosting the shared Stepper.
 */
const MaintenanceStepper = ({ activeView }) => {
  const activeIndex = MAINTENANCE_STEPS.findIndex(step => step.key === activeView);
  if (activeIndex === -1) return null;

  return (
    <div className='mnt-stepper' aria-label='Maintenance progress'>
      <Stepper steps={MAINTENANCE_STEPS} activeIndex={activeIndex} />
    </div>
  );
};

MaintenanceStepper.propTypes = {
  activeView: PropTypes.string,
};

MaintenanceStepper.defaultProps = {
  activeView: null,
};

export default MaintenanceStepper;
